import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4 text-center py-20">
      <div className="font-display text-8xl font-extrabold text-slate-900 tracking-tighter">404</div>
      <div className="mt-2 font-heading text-2xl font-bold text-slate-700">This page couldn&apos;t be located.</div>
      <p className="mt-2 text-slate-500 max-w-md">The URL might be incorrect or the resource may have been moved. Try searching by part number, or return home.</p>
      <div className="mt-6 flex gap-3">
        <Button asChild><Link to="/">Return home</Link></Button>
        <Button asChild variant="outline"><Link to="/search/part">Search by part #</Link></Button>
      </div>
    </div>
  );
}
